export const wrapEmoji = (editor, emoji) => {
  editor.insertText(`${emoji}`);
};
